import {
  IncentiveOffer,
  BeneficiaryAgreedIncentiveOffer,
  IncentiveOfferType,
} from 'modules/incentivesMarket/types';
import {
  BeneficiaryShares,
  BeneficiaryActiveOffers,
  MarketInfo,
  ReferenceInfo,
  RecentActivity,
} from '../types/IncentivesMarketContextType';

export const mockedIncentiveOffers: IncentiveOffer[] = [
  {
    _id: '6601a1b2c3d4e5f6a7b80001',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80101',
      name: 'María García López',
    },
    unitClass: 'Clase A',
    documents: [],
    unitsCount: { total: 100, agreed: 40, approved: 20 },
    unitPrice: 50,
    startDate: '2025-12-01T00:00:00.000Z',
    endDate: '2026-03-31T00:00:00.000Z',
    type: IncentiveOfferType.SELL,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2025-11-28T10:00:00.000Z',
    updatedAt: '2026-01-15T14:30:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80002',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80102',
      name: 'Carlos Rodríguez Martín',
    },
    unitClass: 'Clase B',
    documents: ['64f0a1b2c3d4e5f6a7b8d001'],
    unitsCount: { total: 200, agreed: 200, approved: 200 },
    unitPrice: 55,
    startDate: '2025-11-15T00:00:00.000Z',
    endDate: '2026-02-15T00:00:00.000Z',
    type: IncentiveOfferType.SELL,
    isPartialAmountEnabled: false,
    isSellerNameHidden: false,
    createdAt: '2025-11-10T09:00:00.000Z',
    updatedAt: '2026-01-10T11:20:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80003',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80103',
      name: 'Ana Fernández Ruiz',
    },
    unitClass: 'Clase A',
    documents: [],
    unitsCount: { total: 50, agreed: 5, approved: 0 },
    unitPrice: 48,
    startDate: '2025-12-20T00:00:00.000Z',
    endDate: '2026-06-20T00:00:00.000Z',
    type: IncentiveOfferType.SELL,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2025-12-18T16:45:00.000Z',
    updatedAt: '2026-01-05T08:10:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80004',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80104',
      name: 'Pedro Sánchez Vega',
    },
    unitClass: 'Clase A',
    documents: [],
    unitsCount: { total: 80, agreed: 44, approved: 30 },
    unitPrice: 47,
    startDate: '2025-12-01T00:00:00.000Z',
    endDate: '2026-02-28T00:00:00.000Z',
    type: IncentiveOfferType.BUY,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2025-11-29T12:00:00.000Z',
    updatedAt: '2026-01-20T17:00:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80005',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80105',
      name: 'Laura Díaz Moreno',
    },
    unitClass: 'Clase B',
    documents: ['64f0a1b2c3d4e5f6a7b8d002', '64f0a1b2c3d4e5f6a7b8d003'],
    unitsCount: { total: 100, agreed: 100, approved: 0 },
    unitPrice: 52,
    startDate: '2025-12-10T00:00:00.000Z',
    endDate: '2026-02-10T00:00:00.000Z',
    type: IncentiveOfferType.BUY,
    isPartialAmountEnabled: false,
    isSellerNameHidden: false,
    createdAt: '2025-12-08T14:30:00.000Z',
    updatedAt: '2026-01-25T10:15:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80006',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80106',
      name: 'Inversiones Globales SL',
    },
    unitClass: 'Clase A',
    documents: [],
    unitsCount: { total: 500, agreed: 0, approved: 0 },
    unitPrice: 45,
    startDate: '2026-01-15T00:00:00.000Z',
    endDate: '2026-07-15T00:00:00.000Z',
    type: IncentiveOfferType.SELL,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2026-01-10T08:00:00.000Z',
    updatedAt: '2026-01-10T08:00:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80007',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80107',
      name: 'Javier Morales Torres',
    },
    unitClass: 'Clase C',
    documents: [],
    unitsCount: { total: 150, agreed: 150, approved: 150 },
    unitPrice: 60,
    startDate: '2025-10-01T00:00:00.000Z',
    endDate: '2025-12-31T00:00:00.000Z',
    type: IncentiveOfferType.BUY,
    isPartialAmountEnabled: false,
    isSellerNameHidden: false,
    createdAt: '2025-09-28T11:00:00.000Z',
    updatedAt: '2025-12-20T16:45:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80008',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80108',
      name: 'Elena Navarro Gil',
    },
    unitClass: 'Clase B',
    documents: ['64f0a1b2c3d4e5f6a7b8d004'],
    unitsCount: { total: 75, agreed: 30, approved: 30 },
    unitPrice: 53,
    startDate: '2026-01-01T00:00:00.000Z',
    endDate: '2026-04-01T00:00:00.000Z',
    type: IncentiveOfferType.SELL,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2025-12-28T09:30:00.000Z',
    updatedAt: '2026-01-30T13:00:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80009',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80109',
      name: 'Capital Partners SA',
    },
    unitClass: 'Clase A',
    documents: [],
    unitsCount: { total: 300, agreed: 75, approved: 0 },
    unitPrice: 49,
    startDate: '2026-01-20T00:00:00.000Z',
    endDate: '2026-05-20T00:00:00.000Z',
    type: IncentiveOfferType.BUY,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2026-01-18T15:00:00.000Z',
    updatedAt: '2026-02-01T10:00:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80010',
    society: '64f0a1b2c3d4e5f6a7b89999',
    beneficiary: {
      _id: '64f0a1b2c3d4e5f6a7b80110',
      name: 'Roberto Iglesias Paz',
    },
    unitClass: 'Clase C',
    documents: [],
    unitsCount: { total: 25, agreed: 25, approved: 25 },
    unitPrice: 62,
    startDate: '2025-11-01T00:00:00.000Z',
    endDate: '2025-12-15T00:00:00.000Z',
    type: IncentiveOfferType.SELL,
    isPartialAmountEnabled: false,
    isSellerNameHidden: false,
    createdAt: '2025-10-30T07:00:00.000Z',
    updatedAt: '2025-12-14T18:00:00.000Z',
  },
];

export const mockedBeneficiaryAgreedIncentiveOffers: BeneficiaryAgreedIncentiveOffer[] = [
  {
    incentiveOffer: {
      _id: '6601a1b2c3d4e5f6a7b80001',
      society: '64f0a1b2c3d4e5f6a7b89999',
      beneficiary: '64f0a1b2c3d4e5f6a7b80101',
      unitClass: 'Clase A',
      documents: [],
      unitsCount: { total: 100, agreed: 40, approved: 20 },
      unitPrice: 50,
      startDate: '2025-12-01T00:00:00.000Z',
      endDate: '2026-03-31T00:00:00.000Z',
      type: IncentiveOfferType.SELL,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2025-11-28T10:00:00.000Z',
      updatedAt: '2026-01-15T14:30:00.000Z',
    },
    unitsCount: { agreed: 20 },
    date: '2026-01-10T09:00:00.000Z',
    isApproved: true,
    documents: ['64f0a1b2c3d4e5f6a7b8d010'],
  },
  {
    incentiveOffer: {
      _id: '6601a1b2c3d4e5f6a7b80004',
      society: '64f0a1b2c3d4e5f6a7b89999',
      beneficiary: '64f0a1b2c3d4e5f6a7b80104',
      unitClass: 'Clase A',
      documents: [],
      unitsCount: { total: 80, agreed: 44, approved: 30 },
      unitPrice: 47,
      startDate: '2025-12-01T00:00:00.000Z',
      endDate: '2026-02-28T00:00:00.000Z',
      type: IncentiveOfferType.BUY,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2025-11-29T12:00:00.000Z',
      updatedAt: '2026-01-20T17:00:00.000Z',
    },
    unitsCount: { agreed: 30 },
    date: '2026-01-05T14:20:00.000Z',
    isApproved: true,
    documents: [],
  },
  {
    incentiveOffer: {
      _id: '6601a1b2c3d4e5f6a7b80002',
      society: '64f0a1b2c3d4e5f6a7b89999',
      beneficiary: '64f0a1b2c3d4e5f6a7b80102',
      unitClass: 'Clase B',
      documents: ['64f0a1b2c3d4e5f6a7b8d001'],
      unitsCount: { total: 200, agreed: 200, approved: 200 },
      unitPrice: 55,
      startDate: '2025-11-15T00:00:00.000Z',
      endDate: '2026-01-15T00:00:00.000Z',
      type: IncentiveOfferType.SELL,
      isPartialAmountEnabled: false,
      isSellerNameHidden: false,
      createdAt: '2025-11-10T09:00:00.000Z',
      updatedAt: '2026-01-10T11:20:00.000Z',
    },
    unitsCount: { agreed: 200 },
    date: '2025-12-22T11:00:00.000Z',
    isApproved: true,
    documents: ['64f0a1b2c3d4e5f6a7b8d011', '64f0a1b2c3d4e5f6a7b8d012'],
  },
  {
    incentiveOffer: {
      _id: '6601a1b2c3d4e5f6a7b80005',
      society: '64f0a1b2c3d4e5f6a7b89999',
      beneficiary: '64f0a1b2c3d4e5f6a7b80105',
      unitClass: 'Clase B',
      documents: ['64f0a1b2c3d4e5f6a7b8d002', '64f0a1b2c3d4e5f6a7b8d003'],
      unitsCount: { total: 100, agreed: 100, approved: 0 },
      unitPrice: 52,
      startDate: '2025-12-10T00:00:00.000Z',
      endDate: '2026-02-10T00:00:00.000Z',
      type: IncentiveOfferType.BUY,
      isPartialAmountEnabled: false,
      isSellerNameHidden: false,
      createdAt: '2025-12-08T14:30:00.000Z',
      updatedAt: '2026-01-25T10:15:00.000Z',
    },
    unitsCount: { agreed: 100 },
    date: '2026-01-18T16:30:00.000Z',
    isApproved: false,
    documents: [],
  },
  {
    incentiveOffer: {
      _id: '6601a1b2c3d4e5f6a7b80008',
      society: '64f0a1b2c3d4e5f6a7b89999',
      beneficiary: '64f0a1b2c3d4e5f6a7b80108',
      unitClass: 'Clase B',
      documents: ['64f0a1b2c3d4e5f6a7b8d004'],
      unitsCount: { total: 75, agreed: 30, approved: 30 },
      unitPrice: 53,
      startDate: '2026-01-01T00:00:00.000Z',
      endDate: '2026-04-01T00:00:00.000Z',
      type: IncentiveOfferType.SELL,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2025-12-28T09:30:00.000Z',
      updatedAt: '2026-01-30T13:00:00.000Z',
    },
    unitsCount: { agreed: 15 },
    date: '2026-01-28T10:45:00.000Z',
    isApproved: false,
    documents: ['64f0a1b2c3d4e5f6a7b8d013'],
  },
  {
    incentiveOffer: {
      _id: '6601a1b2c3d4e5f6a7b80009',
      society: '64f0a1b2c3d4e5f6a7b89999',
      beneficiary: '64f0a1b2c3d4e5f6a7b80109',
      unitClass: 'Clase A',
      documents: [],
      unitsCount: { total: 300, agreed: 75, approved: 0 },
      unitPrice: 49,
      startDate: '2026-01-20T00:00:00.000Z',
      endDate: '2026-05-20T00:00:00.000Z',
      type: IncentiveOfferType.BUY,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2026-01-18T15:00:00.000Z',
      updatedAt: '2026-02-01T10:00:00.000Z',
    },
    unitsCount: { agreed: 75 },
    date: '2026-01-30T08:15:00.000Z',
    isApproved: false,
    documents: [],
  },
  {
    incentiveOffer: {
      _id: '6601a1b2c3d4e5f6a7b80001',
      society: '64f0a1b2c3d4e5f6a7b89999',
      beneficiary: '64f0a1b2c3d4e5f6a7b80101',
      unitClass: 'Clase A',
      documents: [],
      unitsCount: { total: 100, agreed: 40, approved: 20 },
      unitPrice: 50,
      startDate: '2025-12-01T00:00:00.000Z',
      endDate: '2026-03-31T00:00:00.000Z',
      type: IncentiveOfferType.SELL,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2025-11-28T10:00:00.000Z',
      updatedAt: '2026-01-15T14:30:00.000Z',
    },
    unitsCount: { agreed: 20 },
    date: '2026-01-22T13:40:00.000Z',
    isApproved: false,
    documents: [],
  },
  {
    incentiveOffer: {
      _id: '6601a1b2c3d4e5f6a7b80007',
      society: '64f0a1b2c3d4e5f6a7b89999',
      beneficiary: '64f0a1b2c3d4e5f6a7b80107',
      unitClass: 'Clase C',
      documents: [],
      unitsCount: { total: 150, agreed: 150, approved: 150 },
      unitPrice: 60,
      startDate: '2025-10-01T00:00:00.000Z',
      endDate: '2025-12-31T00:00:00.000Z',
      type: IncentiveOfferType.BUY,
      isPartialAmountEnabled: false,
      isSellerNameHidden: false,
      createdAt: '2025-09-28T11:00:00.000Z',
      updatedAt: '2025-12-20T16:45:00.000Z',
    },
    unitsCount: { agreed: 150 },
    date: '2025-12-15T17:00:00.000Z',
    isApproved: true,
    documents: ['64f0a1b2c3d4e5f6a7b8d014', '64f0a1b2c3d4e5f6a7b8d015'],
  },
];

export const mockedBeneficiaryShares: BeneficiaryShares = {
  total: 1250,
  acquisitionValue: 62500,
  avgAcquisitionPrice: 50,
  estimatedValue: 75000,
  valueChange: 20,
};

export const mockedBeneficiaryActiveOffers: BeneficiaryActiveOffers = {
  total: 3,
  sellCount: 2,
  buyCount: 1,
  sellAmount: 16000,
  buyAmount: 2940,
};

export const mockedMarketInfo: MarketInfo = {
  totalOffers: 5,
  sellCount: 3,
  buyCount: 2,
  sellAmount: 16000,
  buyAmount: 2940,
};

export const mockedReferenceInfo: ReferenceInfo = {
  lastValuation: 50,
  lastValuationDate: 'Dic 2024',
  totalShares: 12500,
  lastTransactionPrice: 49,
  lastTransactionDate: 'Hace 2 días',
  activeBeneficiariesInMarket: 8,
};

export const mockedRecentActivity: RecentActivity[] = [
  {
    _id: 'activity-001',
    type: IncentiveOfferType.SELL,
    unitsCount: 100,
    unitClass: 'Clase A',
    pricePerShare: 50,
    totalAmount: 5000,
    date: '2026-02-03T10:00:00.000Z',
    daysAgo: 'Hace 2 días',
  },
  {
    _id: 'activity-002',
    type: IncentiveOfferType.SELL,
    unitsCount: 50,
    unitClass: 'Clase B',
    pricePerShare: 52,
    totalAmount: 2600,
    date: '2026-01-31T14:30:00.000Z',
    daysAgo: 'Hace 5 días',
  },
  {
    _id: 'activity-003',
    type: IncentiveOfferType.BUY,
    unitsCount: 80,
    unitClass: 'Clase A',
    pricePerShare: 48,
    totalAmount: 3840,
    date: '2026-01-29T09:15:00.000Z',
    daysAgo: 'Hace 1 semana',
  },
  {
    _id: 'activity-004',
    type: IncentiveOfferType.SELL,
    unitsCount: 200,
    unitClass: 'Clase A',
    pricePerShare: 49,
    totalAmount: 9800,
    date: '2026-01-22T11:00:00.000Z',
    daysAgo: 'Hace 2 semanas',
  },
];
